import React from 'react';
import PropTypes from 'prop-types';
import { i18next, utils } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import isGoogleMapsShortLink from '../helpers/is-google-maps-short-link';
import fieldNames from '../constants/field-names';

const { ControlGroup, InputGroupField, CheckboxField, FieldStatus, Stack } = designSystem;

const LinkForm = ({ control }) => (
  <React.Fragment>
    <Stack gap="spacing-m">
      <div>
        <ControlGroup title={i18next.t('Embed URL')}>
          <InputGroupField
            name={fieldNames.URL_VALUE}
            control={control}
            rules={{
              validate: (value) => {
                if (!utils.validation.isURL(value) || isGoogleMapsShortLink(value)) {
                  return i18next.t('Please enter valid URL');
                }

                return null;
              },
            }}
          />
        </ControlGroup>
        <FieldStatus
          text={i18next.t(
            'Paste the URL of your third-party content here. To embed your content manually, select Embed Code.'
          )}
        />
      </div>

      <CheckboxField
        name={fieldNames.IS_FULLSCREEN_ALLOWED}
        id="fullscreen-checkbox"
        control={control}
        label={i18next.t('Allow full screen')}
      />
    </Stack>
  </React.Fragment>
);

LinkForm.propTypes = {
  control: PropTypes.shape({}).isRequired,
};

export default LinkForm;
